import type { RouteObject } from "react-router-dom";

export const shippingClaimRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Carrier claims" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hidePadding={() => true} /> };
    },
    children: [
      {
        async lazy() {
          const { CarrierClaimsTabsLayout } =
            await import("./carrier-claims-tabs-layout");
          return { Component: CarrierClaimsTabsLayout };
        },
        children: [
          {
            index: true,
            async lazy() {
              const { AdminShippingClaimsPage } =
                await import("./admin-shipping-claims-page");
              return { Component: AdminShippingClaimsPage };
            },
          },
          {
            path: "analytics",
            handle: { breadcrumb: "Analytics" },
            async lazy() {
              const { CarrierClaimsAnalyticsPage } =
                await import("./analytics/carrier-claims-analytics-page");
              return { Component: CarrierClaimsAnalyticsPage };
            },
          },
        ],
      },
    ],
  },
];
